import { Link, useLoaderData } from 'react-router'
import { GeneralErrorBoundary } from '#app/components/error-boundary.tsx'
import WatchCTA from '#app/routes/resources+/watch-cta.tsx'
import { getUserId } from '#app/utils/auth.server.ts'
import { getPostByCarrot } from '#app/utils/posts.server.ts'
import { type Route } from './+types/$carrot.ts'

export const meta = ({ loaderData }: Route.MetaArgs) => {
	// const searchQuery = new URLSearchParams(
	// 	location.search
	//   ).get("q");
    // return [{ title: `Search results for "${searchQuery}"` }];

	var title = `JaseOwns - ${loaderData?.post?.title}`;
	var description = loaderData?.post?.snippet ?? "";
	return [
		{ title: title },
	  	{ name: "description", content: description},
	  	{ name: "keywords", content: "blog,games,uo,ultima online,self taught,learning,jaseowns,jase,jason"},
		{ property: "og:image", content: "https://jaseowns.com/images/blogs/blog-posts-root.png"},
		{ property: "og:image:alt", content: "Blog Posts in orange and white with black background"},
		{ property: "twitter:card", content: "summary"},
		{ property: "twitter:creator", content: "@jaseowns"},
		{ property: "twitter:site", content: "@jaseowns"},
		{ property: "og:title", content: title},
		{ property: "og:description", content: description},
	];
  };
  
export async function loader({ request, params }: Route.LoaderArgs) {
	const carrot = params.carrot ?? ""
	const {post, nextPost, previousPost}  = await getPostByCarrot(carrot)
	const userId = await getUserId(request)
	
	return {
			post,
			nextPost,
			previousPost,
			isAuthor: userId === post.authorId
		}
	
}

export default function BlogPostRoute() {
	const {
		post,
		nextPost,
		previousPost,
		isAuthor
	} = useLoaderData<typeof loader>()

	const replaceEmojisWithHtml = (postBody: string) => {
		
		postBody = postBody.split(":star:").join(`⭐`);
		postBody = postBody.split(":money_with_wings:").join(`💸`);
		postBody = postBody.split(":dollar:").join(`💵`);
		postBody = postBody.split(":pray:").join(`🙏`);
		postBody = postBody.split(":date:").join(`📅`);
		postBody = postBody.split(":calendar_spiral:").join(`📅`);
		postBody = postBody.split(":Schedule:").join(`📅`);
		postBody = postBody.split(":tada:").join(`🎉`);
		postBody = postBody.split(":thankyou:").join(`<img src='/images/thankyou.gif' class="inline-block m-2" alt='Thank You' />`);
		postBody = postBody.split(":YouTube:").join(`<img src='/images/youtube.png' class="inline-block h-12" alt='YouTube' />`);
		postBody = postBody.split(":Twitch:").join(`<img src='/images/twitch.png' class="inline-block h-12" alt='Twitch' />`);
		return postBody;
	}

	const replaceMarkdownWithHtml = (postBody: string) => {

		// Replace ### with <h3>
		postBody = postBody.replace(/^### (.*)$/gm, '<h3 class="text-xl mt-4">$1</h3>');
		// Replace ## with <h2>
		postBody = postBody.replace(/^## (.*)$/gm, '<h2 class="text-2xl mt-4">$1</h2>');
		// Replace # with <h1>
		postBody = postBody.replace(/^# (.*)$/gm, '<h1 class="text-3xl mt-4">$1</h1>');
		// Replace **bold** with <strong>
		postBody = postBody.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
		// Replace *italic* with <em>
		postBody = postBody.replace(/\*(.*?)\*/g, '<em>$1</em>');
		// Replace newlines with <br />
		postBody = postBody.replace(/\n/g, '<br />');
		return replaceEmojisWithHtml(postBody);
	};
	

	const displayContent = (postBody: string) => {
		let postDisplay = replaceMarkdownWithHtml(postBody);
		return <div
				className="quote-child prose-base mb-6"
				dangerouslySetInnerHTML={{__html: replaceContentWithAffiliate(postDisplay)}}
			/>
	}

	const navButtons = () => {
		return <div className="flex flex-col md:flex-row px-10 mb-6 italic text-cyan-900 dark:text-gray-300">
		<Link className="md:px-10 md:mb-6 underline" to={'/blog'}>Back to list</Link> 
		{previousPost ? <Link className="sm:col-span-full md:px-10 md:mb-6 underline" to={`/blog/${previousPost.slug}`}>View Previous Post</Link> : ""}
		{nextPost ? <Link className="sm:col-span-full md:px-10 md:mb-6 underline" to={`/blog/${nextPost.slug}`}>View Next Post</Link> : ""}
	</div>
	}

	return (
		<div className="container mx-auto text-black dark:text-white">
			<div className="flex justify-between items-center">
				<h1 className="text-3xl px-10 mb-6 text-cyan-900 dark:text-cyan-200">{post.title}</h1>
				{isAuthor && (
					<Link 
						to={`/admin/posts/${post.id}/edit`}
						className="px-4 py-2 bg-cyan-600 text-white rounded hover:bg-cyan-700"
					>
						Edit Post
					</Link>
				)}
			</div>
			<h5 className="px-10 mb-6 text-cyan-800 dark:text-cyan-300">
				Posted <b>{new Date(post.publishedAt).toLocaleDateString()}</b> by <Link className="underline" to={`/about`}>{post.author.name}</Link>

				{post.tags != null && post.tags.length ? 
				
				<div>
					Tags: 
					{post.tags.map(x => {
						return <Link className="p-2" key={x.tag.slug} to={`/tags/${x.tag.slug}`}>{x.tag.name}</Link>
					})}
				</div>
				 : 				<div>
				 Tags: 
				 <Link className="p-2" to="/blog">Blog</Link>
			 </div>}

			</h5>

	
			{navButtons()}

			<div className="flex flex-col px-10 mb-6">
				{post.snippet}
			</div>

			{post.snippet !== post.content ? 			<div className="flex flex-col px-10 mb-6">

			{displayContent(post.content)}

				
			</div> : <></>}


			{navButtons()}


			<div className="flex flex-wrap justify-center gap-8 rounded-3xl  py-4">
				{WatchCTA()}
			</div>
		</div>
	)
}

function replaceContentWithAffiliate(content: string) {
	if (content.indexOf("{{INSERT_AFFILIATE_MONSTER}}") >= 0) {
		content = content.split("{{INSERT_AFFILIATE_MONSTER}}").join(`
		<h1 class="text-3xl px-10 mb-6 text-cyan-900 dark:text-cyan-200">Affiliate Link</h1>
		<div class="flex flex-col px-10 mb-6">
			<figure class="max-w-sm">
				<p>One of my favorite beverages is Monster, specifically the ZERO SUGAR Monster. Click the image below to view on Amazon. #ad</p>
				<a href="https://amzn.to/4ls1PlV" className="m-12" title="View on Amazon #ad">
					<img className="h-auto max-w-full rounded-lg" src="/images/monster-pack.png" alt="ZERO SUGAR Monster can" />
					<figcaption className="mt-2 text-sm text-center text-gray-500 dark:text-gray-400">ZERO SUGAR Monster</figcaption>
				</a>
			</figure>
		</div>`)
	}
	return content;
}


export function ErrorBoundary() {
	return (
		<GeneralErrorBoundary
			statusHandlers={{
				404: () => <p>Post not found</p>,
			}}
		/>
	)
}
